// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__8zOCN","content":"MainLayout_content__2MG+d","main":"MainLayout_main__Vf0li"};